export default __webpack_public_path__ + "static/media/cloud-connect.426820ff.yaml";